/**
* Created by vouill on 3/14/18.
*/

<template>
  <div class="main">
    <div>
      <div class="v-title"><div>Nos valeurs</div></div>
      <div class="values">
        <value-item
          v-for="(value , index) in values"
          :key="index"
          :value="value"
          :includes="data.includes"
        />
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.main {
  background-color: #f7f7f7;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 2em;
}

.v-title {
  font-size: 26px;
  color: #ef6c00;
  font-weight: bold;
  font-family: "Roboto Slab", serif;
  padding-top: 2em;
  div {
    padding-bottom: 1em;
  }
}
.values {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>

<script>
import { getEntry } from "../../../utils/contentful";
import ValueItem from "./value-item.vue";

export default {
  components: { ValueItem },
  name: "OurValues",
  props: { data: Object },
  computed: {
    values: function() {
      const { data } = this;
      return (
        data &&
        data.items[0].fields.ourValues.map(value =>
          getEntry(data.includes, value.sys.id)
        )
      );
    }
  }
};
</script>
